package team.platforma.dictionary_presentation.di

import org.koin.compose.viewmodel.dsl.viewModelOf
import org.koin.dsl.module
import team.platforma.dictionary_presentation.DictionaryViewModel

val dictionaryPresentationModule = module {
    viewModelOf(::DictionaryViewModel)
}